export enum FeatureFlag {
  IS_OTP_TOGGLING_ENABLED = 'portal_rollout_toggling_otp',
  ORDER_TYPE_PER_MERCHANT = 'order_type_per_merchant',
  IS_ACCESS_TYPE_CONTROLLED = 'portal_is_access_type_controlled',
  IS_SEGMENTATION_ENABLED = 'portal_is_segmentation_enabled',
  IS_ACCOUNT_ACTIVATION_ENABLED = 'portal_is_account_activation_enabled',
  IS_EMAIL_VERIFICATION_ENABLED = 'portal_is_email_verification_enabled',
  IS_CCOD_ENABLED = 'portal_is_ccod_enabled',
  IS_NEW_SIGN_IN_ENABLED = 'portal_is_new_sign_in_enabled',
  IS_DATA_MIGRATION_WARNING_ENABLED = 'portal_is_data_migration_warning_enabled',
  IS_SCHEDULED_ENABLED = 'portal_scheduled_enabled',
  IS_ESTIMATES_ENABLED = 'portal_estimates_enabled',
  IS_ZONE_VALIDATION_ENABLED = 'portal_is_zone_validation_enabled',
  IS_TRANSPORTER_TRACKING_ENABLED = 'portal_is_transporter_tracking_enabled',
  IS_NEW_INVOICES_API_ENABLED = 'portal_is_new_invoices_api_enabled',
  IS_NEW_CARDS_API_ENABLED = 'portal_is_new_cards_api_enabled',
  IS_LOCATIONS_REVERSE_GEOCODING_DISABLED = 'portal_is_locations_reverse_geocoding_disabled',
  IS_ONE_CLICK_DISABLED = 'portal_is_one_click_disabled'
}
